import React from "react";
import PropTypes from "prop-types";
import { formatLocalDateTimeStr } from "../../utils/DateUtils";

const LocalDateTimeStringFormatter = ({ value }) => {
  return <div>{value ? formatLocalDateTimeStr(value) : null}</div>;
};

LocalDateTimeStringFormatter.propTypes = {
  value: PropTypes.number
};

export default LocalDateTimeStringFormatter;
